import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {Config} from '../../Config'
import * as Icon from "react-bootstrap-icons";

export default function ChangePw() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);

    let [newPasswordInputType, setNewPasswordInputType] = React.useState('password');
    let [confirmNewPasswordInputType, setConfirmNewPasswordInputType] = React.useState('password');
    let [currentPasswordInputType, setCurrentPasswordInputType] = React.useState('password');

    let refPassword = React.useRef();
    let refConfirmPassword = React.useRef();
    let refCurrentPassword = React.useRef();

    const onUpdate = () => {
        let password = refPassword.current.value;
        let confirmPassword = refConfirmPassword.current.value;
        let currentPassword = refCurrentPassword.current.value;
        if(!password) {
            toast.error("กรุณาระบุ รหัสผ่านใหม่");
            refPassword.current.focus();
        }
        else if(!Utils.strengthPassword.test(password)) {
            toast.error("รหัสผ่านต้องประกอบไปด้วย\n- ภาษาอังกฤษ\n- ตัวเล็ก/ตัวใหญ่\n- อย่างน้อย 6-20 ตัวอักษร");
            refPassword.current.focus();
        }
        else if(!confirmPassword) {
            toast.error("กรุณาระบุ ยืนยันรหัสผ่านใหม่");
            refConfirmPassword.current.focus();
        }
        else if(password !== confirmPassword) {
            toast.error("รหัสผ่านไม่ตรงกัน");
            refConfirmPassword.current.focus();
        }
        else if(!currentPassword) {
            toast.error("กรุณาระบุ รหัสผ่านปัจจุบัน");
            refCurrentPassword.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);
                            const body = {
                                id: userId,
                                password: password,
                                currentPassword: currentPassword,
                                updatedBy: userId
                            };
                            fetch(Config.url.API_URL +'/api/user/changePassword', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย", {autoClose: 2000});
                                    setTimeout(function () {
                                        refPassword.current.value = '';
                                        refConfirmPassword.current.value = '';
                                        refCurrentPassword.current.value = '';
                                    }, 2000);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    let [validPassword, setValidPassword] = React.useState(true);
    const onKeyUpPassword = (e) => {
        if(e.target.value) {
            let valid = Utils.strengthPassword.test(e.target.value);
            setValidPassword(valid);
        }
        else {
            setValidPassword(true);
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Users Management</div>
                    <span className="ms-1">/</span> <span className="text-muted">Change Password</span>
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="password" className="form-label">รหัสผ่านใหม่</label>
                                <div className="position-relative">
                                    <input type={newPasswordInputType} className="form-control" id="password" ref={refPassword} maxLength={20} onKeyUp={e => onKeyUpPassword(e)} />
                                    <div className="eye-password" onClick={e => {setNewPasswordInputType(newPasswordInputType === 'password' ? 'text':'password')}}>
                                        {newPasswordInputType === 'text' ? <Icon.Eye /> : <Icon.EyeSlash />}
                                    </div>
                                </div>

                                <p className={!validPassword ? 'text-danger mb-0 small':'d-none'}>รูปแบบรหัสผ่านไม่ถูกต้อง</p>
                                <p className="mb-0 mt-2 small text-muted">* ต้องประกอบไปด้วย<br />- ภาษาอังกฤษ<br />- ตัวเล็ก/ตัวใหญ่<br />- อย่างน้อย 6-20 ตัวอักษร</p>
                            </div>
                            <div className="col-12">
                                <label htmlFor="confirmPassword" className="form-label">ยืนยันรหัสผ่านใหม่</label>
                                <div className="position-relative">
                                    <input type={confirmNewPasswordInputType} className="form-control" id="confirmPassword" ref={refConfirmPassword} maxLength={20} />
                                    <div className="eye-password" onClick={e => {setConfirmNewPasswordInputType(confirmNewPasswordInputType === 'password' ? 'text':'password')}}>
                                        {confirmNewPasswordInputType === 'text' ? <Icon.Eye /> : <Icon.EyeSlash />}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="currentPassword" className="form-label">รหัสผ่านปัจจุบัน</label>
                                <div className="position-relative">
                                    <input type={currentPasswordInputType} className="form-control" id="currentPassword" ref={refCurrentPassword} maxLength={20} />
                                    <div className="eye-password" onClick={e => {setCurrentPasswordInputType(currentPasswordInputType === 'password' ? 'text':'password')}}>
                                        {currentPasswordInputType === 'text' ? <Icon.Eye /> : <Icon.EyeSlash />}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 